import { AUTH_BACKUP_CODE_LABEL, AUTH_BACKUP_CODE_LENGTH, AUTH_CODE_PLACEHOLDER } from 'common/constants/auth';
import { AuthTextField } from 'pages/Auth/components/AuthTextField';
import { getFirstFieldMessage } from 'pages/Auth/components/OTP/OTP.utils';
import { AuthenticationBackupCodesInputProps } from './AuthenticationBackupCodesInput.props';

const AuthenticationBackupCodesInput = ({
  disabled = false,
  formState,
  handleBlur,
  handleChange,
  inputRef,
  onKeyDown,
}: AuthenticationBackupCodesInputProps) => {
  const { dbErrors, errors, touched, values } = formState;
  const helperText = touched.backupCode ? getFirstFieldMessage(errors?.backupCode) : undefined;
  const hasError = Boolean(helperText || getFirstFieldMessage(dbErrors?.backupCode));

  return (
    <AuthTextField
      autoCapitalize="off"
      autoComplete="one-time-code"
      autoCorrect="off"
      disabled={disabled}
      id="enter-user-backup-code"
      slotProps={{
        htmlInput: {
          maxLength: AUTH_BACKUP_CODE_LENGTH,
          onBlur: handleBlur,
          pattern: '[a-z2-7]*',
          spellCheck: false,
        },
      }}
      name="backupCode"
      label={AUTH_BACKUP_CODE_LABEL}
      placeholder={AUTH_CODE_PLACEHOLDER}
      type="text"
      error={hasError}
      helperText={helperText}
      value={values.backupCode || ''}
      inputRef={inputRef}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default AuthenticationBackupCodesInput;
